module.exports = __webpack_public_path__ + "static/media/screen4.9db7b328.png";